import { LogIn } from "lucide-react";

export default function AdminLogin() {
  function onLogin() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }
  return (
    <div className="pt-16 md:pt-20 min-h-[80vh] flex items-center justify-center" data-testid="page-admin-login">
      <div className="max-w-md w-full mx-auto px-6">
        <div className="rounded-3xl border border-stone bg-white p-10 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-4">Admin</div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-navy tracking-tight">Sign in to view submissions</h1>
          <p className="mt-4 text-slate">
            Access is limited to allowlisted emails. Sign in with your Google account.
          </p>
          <button
            onClick={onLogin}
            data-testid="admin-google-signin"
            className="btn-primary mt-8 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold w-full justify-center"
          >
            <LogIn size={16}/> Sign in with Google
          </button>
        </div>
      </div>
    </div>
  );
}
